import { Link } from '@tanstack/react-router';
import { LOANREQUEST_DEFAULT_STATUS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuFolderSync } from 'react-icons/lu';

import { useBucketCounts } from './hooks/useBucketCounts';
import { LEAD_LIST_DEFAULT_FILTERS } from '~/constants';

export const BucketSummary = () => {
    const { t } = useTranslation();
    const { data: counts } = useBucketCounts();

    const unassignedCount = counts?.[LOANREQUEST_DEFAULT_STATUS.ALL] ?? 0;

    return (
        <Link
            to="/bucketLeads"
            search={LEAD_LIST_DEFAULT_FILTERS}
            activeOptions={{ includeSearch: false }}
            className="group flex items-center px-2 py-1 gap-2 text-sm rounded transition-all"
            inactiveProps={{ className: 'text-white hover:bg-white hover:text-[#1e2b43]' }}
            activeProps={{ className: 'bg-white text-[#1e2b43]' }}
        >
            <>
                {unassignedCount > 0 ? (
                    <span className="flex items-center justify-center min-w-4 h-4 rounded-full text-[9px] font-bold shrink-0 tabular-nums px-1 bg-white text-midnight group-data-[status=active]:bg-midnight group-data-[status=active]:text-white group-hover:bg-midnight group-hover:text-white">
                        {unassignedCount}
                    </span>
                ) : (
                    <LuFolderSync className="w-3.5 h-3.5" />
                )}
                <span>{t('TOP_HEADER.NAV_BAR.BUCKET_SUMMARY')}</span>
            </>
        </Link>
    );
};
